import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import axios from "axios";
import Constants from '../App/Variables/Constants';
import "bootstrap/dist/css/bootstrap.min.css";

const Design = ({ 
    product,
    designId,
    setDesignId,
    setRectangles,
    setKonvaImage1,
    setFillImageUrl,
    setFabric2Image,
    setCurrentDesign,
    setFabric2Id,
    setAllThread }) => {

    const [getAllDesign, setAllDesign] = useState([]);

    const handleAddImage = (src, type, id) => {
        let x = 0;
        let y = 0;
        let width = 599;
        let height = 599;

        setKonvaImage1(null);
        setFillImageUrl("");
        setFabric2Image([]);
        setFabric2Id("");


        if (type == "art2") {
            x = 0;
            y = 0;
            width = 599;
            height = 599;
        } else if (type == "fabric2") {
            setFabric2Id(id);
            x = 150;
            y = 80;
            width = 150;
            height = 150;
        }
        setRectangles((prevImages) => {
            const updatedImages = [...prevImages];
            const existingImageIndex = updatedImages.findIndex(
                (image) => image.type === type
            );

            // If there is an existing image of the same type, replace it
            if (existingImageIndex !== -1) {
                setDesignId((prevIds) => {
                    const newIds = [...prevIds];
                    newIds[existingImageIndex] = id; // Update the ID for the existing type
                    return newIds;
                });
                updatedImages[existingImageIndex] = {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    id: `rect${updatedImages.length + 1}`,
                    src: src,
                    type: type, // Add type to identify image type
                };
            } else {
                if (type != "fabric2") {
                    setDesignId((prevIds) => [...prevIds, id]);
                }
                // Add new image if not already present
                updatedImages.push({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    id: `rects${updatedImages.length + 1}`,
                    src: src,
                    type: type, // Add type to identify image type
                });
            }
            return updatedImages;
        });
    };

    // const handleSetColor = (color) => {
    //     setAllThread(color);
    // };

    const getDesign = () => {
        if(product.category && product.sub_category){
        axios
            .get(`${Constants.getUrls.getAllDesign}?limit=${100}&categoryId=${product.category}&collectionId=${product.sub_category}`)
            .then((resp) => {
                if (resp.data.status === "success") {
                    setAllDesign(resp.data.data);
                }
            })
            .catch((error) => {
                console.error("Error in stylesChange:", error);
            });
        }
    };

    useEffect(() => {
        getDesign();
    }, [])
    console.log("--------------aaa", getAllDesign);
    
    return (
        <div 
         className="row flex-column border border-3 border-dark overflow-hidden rounded-5 my-3"
         style={{ backgroundColor: "white"}}
        >
            <div className="col-12">
                <div className="row flex-column gap-4 py-4">
                    {getAllDesign.length > 0 ? (
                        <Tabs
                            id="fabric-design-tabs"
                            className="mb-3"
                        >

                            {getAllDesign.map((fabricGroup, i) => (
                                <Tab
                                    key={i + 2}
                                    eventKey={fabricGroup.design_type == "art1"
                                        ? "Art 1"
                                        : fabricGroup.design_type == "art2"
                                            ? "Art 2"
                                            : ""}

                                    title={fabricGroup.design_type == "art1"
                                        ? "Art1"
                                        : fabricGroup.design_type == "art2"
                                            ? "Art2"
                                            : ""}
                                >
                                    {fabricGroup.fabrics.length > 0 ? ( // Check fabrics length for the group
                                        <div className="d-flex flex-wrap gap-2">
                                            {fabricGroup.fabrics.map((design, j) => (
                                                design.images.map((image, k) => (
                                                    image.is_main === 1 &&
                                                    <img
                                                        style={{ width: "80px", display: "inline", cursor: "pointer" }}
                                                        className={`img-fluid ${designId.includes(image._id)
                                                            ? "border-selected"
                                                            : ""
                                                            }`}
                                                        key={image._id}
                                                        onClick={() => {

                                                            handleAddImage(
                                                                `${Constants.imgDomain + image.image}`,
                                                                `${design.design_type}`,
                                                                `${design._id}`
                                                            )
                                                            // handleSetColor()
                                                            setAllThread(design)
                                                            setCurrentDesign(design)
                                                        }}
                                                        src={Constants.imgDomain + image.image}
                                                        alt=""
                                                    />
                                                ))
                                            ))}
                                        </div>
                                    ) : (
                                        <p>No designs available.</p>
                                    )
                                    }
                                </Tab>
                            ))}
                        </Tabs>

                    ) : (
                        <p style={{ color: "black" }}>Loading designs...</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Design